import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {PUSH_NOTIFICATIONS_PROMPT_TYPES} from '@/consts/pushNotifications/pushNotificationsPromptTypes';
import useOnFocusChange from '@/hooks/useOnFocusChange';
import useOnVisibilityChange from '@/hooks/useOnVisibilityChange';
import {
    checkIsShowPushPrompt,
    schedulePushPromptIfNeeded,
} from '@/services/pushNotification/pushNotificationPromptService';
import {selectIsLoggedIn} from '@/state/selectors/auth';
import {selectIsTncApproved} from '@/state/selectors/consumerAggregatedSettings';

const usePushNotificationsPrompt = () => {
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const isTncApproved = useSelector(selectIsTncApproved);

    const schedulePushPrompt = async () => {
        if (!isLoggedIn || !isTncApproved) return;

        await schedulePushPromptIfNeeded(PUSH_NOTIFICATIONS_PROMPT_TYPES.REGULAR);
        await checkIsShowPushPrompt();
    };

    useEffect(() => {
        schedulePushPrompt();
    }, [isLoggedIn, isTncApproved]);

    useOnVisibilityChange(schedulePushPrompt);
    useOnFocusChange(schedulePushPrompt);
};

export default usePushNotificationsPrompt;
